export default __webpack_public_path__ + "static/media/Little_Mermaid_Normal_B.c84f207e.wav";